export const classes = {
  card: 'flex items-start gap-[30px] max-sm:flex-col max-sm:gap-5',
  imageColumn: 'flex flex-none flex-col items-center gap-3',
  imageWell:
    'rounded-[20px] border border-hair2 bg-image-well bg-black/[0.04] px-8 py-6 dark:border-hair2-dark dark:bg-image-well-dark dark:bg-white/[0.07]',
  image: 'block w-[206px] rounded-xl shadow-bottle',
  copyColumn: 'flex min-w-0 flex-1 flex-col gap-4 pt-1.5',
  eyebrow:
    'font-mono text-xs font-bold leading-none tracking-[0.16em] text-brand-accent dark:text-brand-accent-dark',
  title:
    'mt-2 text-4xl font-extrabold leading-[1.02] tracking-[-0.03em] text-taupe-3 dark:text-mauve-1',
  subtitle: 'mt-[7px] text-base font-medium text-taupe-2 dark:text-mauve-2',
  description:
    'max-w-[52ch] [text-wrap:pretty] text-sm leading-[1.62] text-taupe-2 dark:text-mauve-2',
  pills: 'flex flex-wrap gap-2',
  pillStock:
    'flex items-center gap-1.5 rounded-full bg-pos/[0.14] px-3 py-1.5 text-xs font-bold text-pos dark:bg-pos-dark/[0.14] dark:text-pos-dark',
  pill: 'rounded-full border border-hair px-3 py-1.5 text-xs font-semibold text-taupe-2 dark:border-hair-dark dark:text-mauve-2',
};
